import commonStyles from "./common";

const styles = {
  tableColWithWidth15: {
    ...commonStyles.tableCol,
    width: "15%"
  },
  relationShipWidth: {
    ...commonStyles.tableCol,
    width: "27%"
  },
  nomineesTable: {
    ...commonStyles.table,
    marginTop: 5
  },
  epfNomineesRelationship: {
    ...commonStyles.tableCol,
    width: "15%",
    textAlign: "center"
  },
  epfAmountShare: {
    ...commonStyles.tableCol,
    width: "10%",
    textAlign: "center"
  },
  epfGuardianDetails: {
    ...commonStyles.tableCol,
    width: "20%",
    textAlign: "center"
  },
  subscriberSignature: { marginTop: 40, textAlign: "right", marginRight: 40 },
  nameAndAddressWidth: {
    ...commonStyles.tableCol,
    width: "58%"
  },
  epfDOB: {
    ...commonStyles.tableCol,
    width: "14%"
  },
  gratuityProportion: { ...commonStyles.tableCol, width: "16%" },
  partsBHeader: { ...commonStyles.header, marginBottom: 6, marginTop: 13 },
  headerParagraph: {
    marginTop: 10,
    fontWeight: "regular"
  },
  nomineeCertifiedStatement: { margin: "10 0" },
  nomineeTable: { ...commonStyles.table, margin: "10 0" },
  form2DeclarationDate: {
    ...commonStyles.declarationPlaceDateStyles,
    marginTop: 15
  },
  form2DeclarationSignature: {
    ...commonStyles.declarationSignature,
    marginTop: 15
  },
  employeeDetails: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 8
  },
  employeeDetailsKey: {
    width: "40%"
  },
  employeeDetailsValue: {
    width: "50%"
  },
  paddingLeft55: {
    paddingLeft: 55
  }
};

export default styles;
